function init_girlown(from_php){
    if(from_php.girl_id==0){
        return false;
    }
    
    var main=$(".place.girlown");
    var timeIndexList=_moduleTimeHandler.getNewIndex();
    
    function showEnergyBook(skill_id){
        var book=main.find(".book.bookTrainingStartJS");
        book.bookUse(("show"));
        var cam_id,cam_id_init=1,energy_have=_myProfile.takeData("energy");
        var camList=book.find("#putStartListJS"),formObj=book.find("#trainStartFormJS");
        var html="",bum;
        for(cam_id in from_php.train_stat){
            bum=from_php.train_stat[cam_id];
            html+=
            "<div class='cell' data-cam_id='"+cam_id+"'>"+
                "<div class='imgWrap'>"+
                "</div>"+
                "<div class='statWrap'>"+
                    "<div class='shOne timeOne'>"+timeFormat(bum.howlong)+"</div>"+
                    "<div class='shOne energy'>-"+bum.energy+"</div>"+
                "</div>"+
            "</div>";
            if(energy_have>=bum.energy){
                cam_id_init=cam_id;
            }
        }
        
        var cur_cam_id,stat_cur,inputHowmany=main.find("#girlTrainingInput");
        var howmany_conf={
            "1":[1,3,6,12,24,48,72,96,144],
            "2":[1,2,4,8,12,16,24],
            "3":[1,2,3,4,6]
        };
        camList.html(html).find(".cell[data-cam_id]").click(function(){
            camList.find(".cell[data-cam_id]").removeClass("active");
            var th=$(this);
            cur_cam_id=intval(th.attr("data-cam_id"));
            stat_cur=copyObj(from_php.train_stat[cur_cam_id]);
            //debugArr(stat_cur); howlong
            //number,end_big,is_big,end_small,big_from_val
            
            formObj.find(".energyJS").attr("data-need",stat_cur.energy+"e").updateButton().
                    filter(".shOne").html("-"+stat_cur.energy);
            th.addClass("active");
            formObj.find("input[type='hidden'][name='start_training']").attr("value",cur_cam_id);
            formObj.find("input[type='hidden'][name='skill_id']").attr("value",skill_id);
            
            formObj.find(".shOne.skillfight").attr("data-type",skill_id).html("+"+numberFormat(stat_cur.add,2,1,0,10000000));
            formObj.find(".timeOneJS").html(timeFormat(stat_cur.howlong));
            formObj.find("input[type='hidden'][name='howmany_training']").attr("value",1);
            
            inputHowmany.myFormText("remove");
            inputHowmany.myFormText({val:1,val_arr:howmany_conf[cur_cam_id],on_update:function(val){
               formObj.find(".shOne.skillfight").attr("data-type",skill_id).html("+"+numberFormat(stat_cur.add*val,2,1,0,10000000));
               formObj.find(".timeOneJS").html(timeFormat(stat_cur.howlong*val));
               formObj.find("input[type='hidden'][name='howmany_training']").attr("value",val);
            }});
            inputHowmany.myFormText("update",1);
            //giftInput.myFormText("update",howmany);
//            giftInput.myFormText({val_arr:[1,5,10,50,100,500,1000,5000,10000],on_update:function(val){
//                showGift(cur_gift_id,val);
//            }});
            
            
        }).filter("[data-cam_id='"+cam_id_init+"']").trigger("click");
        
        
        //trainStartFormJS
    }
    function updateDuring(){
        var buttonObj=main.find("#traningCallJS"),beltObj=buttonObj.find(".fillWrap");
        var row=from_php.train_row;
        var timer_selector=".place.girlown .duringTextJS";
        var time_cur=getCurrentTime();
        var showOnStart=buttonObj.find(".showOnStartJS");
        //zacznij,zbierz,trwa
        beltObj.hide();
        if(row.skill_energy==0){
            //begin
            showOnStart.show();
        }
        else{
             _timerManager.deleteTimer(timer_selector);
            var time_end=row.time_start+row.howlong_end-row.howlong_have;
            if(row.time_start>1 && time_end<=time_cur){
                //collect
                if(buttonObj.find(".arrowView").length==0){
                    buttonObj.append("<div class='arrowView'></div>");
                    buttonObj.find(".arrowView").myUpDown({'rotation':90,left:-60,top:-10});
                }
                showOnStart.show();
            }
            else{
                //during
                showOnStart.hide();
                beltObj.show();
                if(row.time_start>1){
                    beltObj.find(".fill").beltTimer(time_cur-row.time_start+row.howlong_have,row.howlong_end,time_end,{
                        "on_end_timer":function(){
                            updateDuring();
                        }
                    });
                    _timerManager.addTimer(timer_selector,time_end,1,function(){});
                    
                }
                else{
                    beltObj.find(".fill").width((row.howlong_have/row.howlong_end*100)+"%");
                    $(timer_selector).html(timeFormat(row.howlong_end-row.howlong_have));
                }
               
            }
        }
        
    }
    function takePremiumCost(premium_time_cost,premium_time_cost_old){
        var room=from_php.train_row;
//        var premium_time_cost_old=from_php.premium_time_cost_old;
        var howlong=room.howlong_end-room.howlong_have;
        if(room.time_start>1){
            howlong-=getCurrentTime()-room.time_start;
        }
        var val_old=Math.ceil(howlong/premium_time_cost_old);   
        if(room.skill_type_id!=4){
            val_old=Math.min(val_old,intval(from_php.premium_cost_max));
        }
        
        var val=Math.ceil(val_old*premium_time_cost_old/premium_time_cost);
        val=Math.max(1,val);
        return val;
    }
    function updateDuringPremiumCost(lastPremium,lastPremiumOld){
        var row=main.find(".book.duringBook .rowPremium");
        row.find('.myButton.premium').premiumLess({price_old:lastPremiumOld,price_cur:lastPremium});
        row.find("input[name='end_by_premium']").attr("value",lastPremium);
        var showHide=main.find(".duringBook .lessPromoJS");
        if(lastPremium!=lastPremiumOld){
            showHide.show();
        }
        else{
            showHide.hide();
        }
    }
    function showDuringBook(){
       var duringBook=main.find(".book.duringBook");
        var room=from_php.train_row;
        var time_cur=getCurrentTime();
        duringBook.bookUse("show");
        var buttonCol=duringBook.find(".actionButJS .myButton");
        var fillObj=duringBook.find(".duringFilmBar .fill");
        duringBook.find(".onStartJS,.onStopJS").hide();
        
        var premium_time_cost=from_php.premium_time_cost,
        premium_time_cost_old=from_php.premium_time_cost_old;
        if(typeof room.training_extra.premium_cost=="undefined"){
            duringBook.find(".textAddJS").html("+"+numberFormat(from_php.train_row.skill_add,2,1,0,10000000));
        }
        else{
            var stat_conf={"1":"stat_attack","2":"stat_speed","3":"stat_critical"},i,bum;
            for(i in stat_conf){
                bum=stat_conf[i];
                duringBook.find(".wrapManyIcons .cell[data-training_id='"+i+"'] .textAddJS").html(
                    "+"+numberFormat(room.training_extra[bum],2,1,0,10000000)
                );
            }
            premium_time_cost=Math.round(room.howlong_end/room.training_extra.premium_cost);
            premium_time_cost_old=Math.round(room.howlong_end/room.training_extra.premium_cost_old);
        }
        
        var lastPremium=takePremiumCost(premium_time_cost,premium_time_cost_old);
        updateDuringPremiumCost(lastPremium,takePremiumCost(premium_time_cost_old,premium_time_cost_old));
        if(room.time_start>1){
            duringBook.find(".onStopJS").show();
            var time_end=room.time_start+room.howlong_end-room.howlong_have;
            fillObj.beltTimer(time_cur-room.time_start+room.howlong_have,room.howlong_end,time_end,{
                "on_end_timer":function(){
                    if(duringBook.is(":visible")){
                        duringBook.bookUse("hide");
                    }
                },
                "on_step":function(){
                    var premiumCost=takePremiumCost(premium_time_cost,premium_time_cost_old);
                    if(premiumCost!=lastPremium){
                        lastPremium=premiumCost;
                        updateDuringPremiumCost(lastPremium,takePremiumCost(premium_time_cost_old,premium_time_cost_old));
                    }
                    //premium_time_cost
                }
            });
            
        }
        else{
            duringBook.find(".onStartJS").show();
            fillObj.beltTimer("clear");
            fillObj.width((room.howlong_have/room.howlong_end*100)+"%");
        }
    }
    
    function initGirlBook(type){
        var girlsArr;
        if(type=="own"){
            girlsArr=from_php.girls;
        }        
        else{
            girlsArr=from_php.girls_special;
        }     
        
        var girlCell=main.find(".cellBig.girlsSet").hide().filter("[data-type='"+type+"']").show(); 
       
        var girlList=girlCell.find(".girlList");
        var html="",html_part,i,girl,girlShow=0;
        girlList.myPageSelector("clear");
        for(i in girlsArr){
            girl=girlsArr[i];
            html_part=
            '<div class="cell myLink" action="girlown/'+girl.girl_id+'/" data-girl_id="'+girl.girl_id+'">'+
                '<div class="girlProfile"></div>';
                if(girl.can_collect){
                     html_part+='<div class="collectTraining"></div>';
                }
            html_part+=
            '</div>'; 
            html_part=$("<div id='wrapTmp'>"+html_part+"</div>").find(".girlProfile").girlProfile({girlArr:girl,size:"small"}).closest("#wrapTmp").html();
            html+=html_part;  
        }
        girlList.html(html).myPageSelector({width:112,height:565,page:from_php.page});//
        var toCollect=girlList.find(".cell .collectTraining"),step=0;
        _moduleTimeHandler.clear(timeIndexList);
        _moduleTimeHandler.set(timeIndexList,function(){
            step=(step+1)%2;
            toCollect.attr("data-step",step);
        },1000);
        
        girlList.handleXHR();
        var cellChange=main.find("#cellChange");
        cellChange.find(".tab").removeClass("active").filter("[data-type='"+type+"']").addClass("active");
        cellChange.find(".tab").off("click.ccL").on("click.ccL",function(){
            var th=$(this),type=th.attr("data-type");
           initGirlBook(type);
        });
    }
    function initFightButton(){
        var fight_time=intval(from_php.fight_time);
        var timerKey="#pvpTimer .val,#timerGirlFightJS";
        if(fight_time>=getCurrentTime()){
            //pvpTimer del
            //(selector,time_end,delete_on_module_load,funOnEnd)
            _timerManager.addTimer(timerKey,fight_time,1,function(){
                main.find("#pvpTimer").remove();
            });
        }
        else{
            main.find("#pvpTimer").remove();
        }
        main.find("#fightTriggerJS,.fightTriggerJS").click(function(){
            var th=$(this);
            if(fight_time>=getCurrentTime()){
                $(".book.fightWaitBook").bookUse("show");
            }
            else{
                var data_type=intval(th.attr("data-type")),
                url="fight/"+from_php.girl_id+"/";
                if(data_type){
                    url+=data_type+"/";
                }
                $.goToLocation(url);
                
            }
            return false;
        });
    }
    if(from_php.girl_id>1000){
        initGirlBook("special");
    }
    else{
        initGirlBook("own");
    }
    
    
    
    initFightButton();
    updateDuring();
    main.find(".book.bookTrainingInitJS .cell[data-skill_id]").click(function(){
        var skill_id=intval($(this).attr("data-skill_id"));
        if(skill_id<4){
            showEnergyBook(skill_id);
        }
        else{
            $.goToLocation("girlown",{training_extra:1});
        }
        
        return false;
    });
    main.find("#traningCallJS").click(function(){
        var row=from_php.train_row;
        if(row.skill_energy==0){
            main.find(".book.bookTrainingInitJS").bookUse("show");
        }
        else{
            if(row.time_start>1 && row.time_start+row.howlong_end-row.howlong_have<=getCurrentTime()){
                //collect
                $.goToLocation("girlown/"+from_php.girl_id+"/",{end_training:1})
            }
            else{
                showDuringBook();
            }
        }
        return false;
    });//.trigger("click");
    var girlObj=new girlSuitView(from_php.girl_id,from_php.suit_obj);
    girlObj.makeView(main.find("#girlMainView"));
    if(from_php.q_id){
        switch (from_php.q_id) {
            case 1:main.find("#traningCallJS").trigger("click");break;
            case 2:main.find("#fightTriggerJS").trigger("click");break;
            case 3:showDuringBook();break;
        }
    }
    
    
    var fighterObj= new girlFightView(from_php.girl_id,main.find("#pvpStatBoxJS"),from_php.fighterStat);
    fighterObj.start();
    
    function initTV(){
        var row=from_php.train_row;
        var sceneConf={
            "1":{"step_max":10,"width":304,"interval":80},
            "2":{"step_max":3,"width":297,"interval":125},
            "3":{"step_max":10,"width":297,"interval":50},
        };
        var type_id=1;
        if(row.skill_energy==5){
            type_id=2;
        }
        else if(row.skill_energy==10){
            type_id=3;
        }
        var conf=sceneConf[type_id];
        conf.scene_range=[conf.step_max,conf.step_max];
        var tvObj=main.find("#tvTraining"),tvObjAnim=tvObj.find(".anim");
        
        if(row.time_start>1){
            tvObj.find(".reflex").hide();
            tvObj.find(".back").eq(1).hide();
            tvObj.find(".anim").attr("data-img",type_id).show().myEye(conf);
            var dioda_step=0;
            _moduleTimeHandler.add(function(){
                dioda_step=(dioda_step+1)%2;
                if(dioda_step==1){
                    tvObj.find(".dioda").hide();
                }
                else{
                    tvObj.find(".dioda").show();
                }
            },1000);
            var lightObj=tvObj.find(".light").show();
            function lightFast(){
                lightObj.fadeOut(500,function(){
                   lightObj.fadeIn(500,function(){
                       lightFast();
                   }); 
                });
            }
            lightFast();
        }
        else{
            tvObj.find(".dioda").hide();
        }
        
        tvObj.find(".cellToClick.up").click(function(){
           main.find("#traningCallJS").trigger("click");
           return false;
        });
    }
    initTV();
    
    function explainWindow(){
        var book=main.find(".book.explain");
        var ps=book.find(".rewardJS").myPageSelector({height:60,width:290});
        book.on("open",function(){
            //update
            ps.myPageSelector("setPage",1);
        });
        //pvp_end_time
        _timerManager.addTimer(".leaguePvPeNDJS",from_php.pvp_end_time,1);
    }
    explainWindow();
    
    function halloweenWindow(){
        _timerManager.addTimer("#halloweenUI .timerWrap .val",from_php.halloween_time,1,function(){
            main.find("#halloweenUI").remove();
        });
        var step=0,step_view,dir=1,obj=main.find("#pumpkinUI"),border=10;
        _moduleTimeHandler.add(function(){
            step+=dir;
            if(step<0-border || step>4+border){
                dir=dir*(-1);
                
            }
            step_view=Math.min(step,4);
            step_view=Math.max(step_view,0);
            obj.attr("data-step",step_view);
        },80);
        
    }
    
    halloweenWindow();
    
    function christmasWindow(){
        var box=main.find("#christmasBox");
        box.find(".eye").myEye();
        var step=0,dir=1,step_max=50;
        var light=box.find(".light");
        _moduleTimeHandler.add(function(){
            step+=dir;
            if(step>=step_max){
                dir=-1;
            }
            if(step<=0){
                dir=1;
            }
            light.css("opacity",step/step_max);
        },50);
    }
    christmasWindow();
    
    if(typeof from_php.special_event!=="undefined"){
        var fun_name="init_girlown_"+from_php.special_event.name;
        if (eval("typeof " + fun_name + " == 'function'")) {
            var fn = window[fun_name];
            fn(from_php);
        }
    }
    if(typeof from_php.event_end!=="undefined"){
        //(selector,time_end,delete_on_module_load,funOnEnd)
        _timerManager.addTimer(".place.girlown #carnivalUI .timer",from_php.event_end,1);
    }
    if(typeof from_php.valen_end!=="undefined" && from_php.valen_end>getCurrentTime()){
        //(selector,time_end,delete_on_module_load,funOnEnd)
        _timerManager.addTimer(".place.girlown #valenUI .timer",from_php.valen_end,1);
        var girlObj=new girlSuitView(1003,{12:295});
        girlObj.makeView(main.find("#valenUI .icon"));
    }
    var obj=main.find("#carnivalUI[data-type='patrick'] .icon");
    if(obj.length){
        obj.qAnim({width:166, clips:9,
            interval:150,
            loop:1,
            two_side:1})
    }
    
    var obj=main.find("#easterUI .icon");
    if(obj.length){
        obj.qAnim({width:185, clips:8,
            interval:60,
            loop:1,
            });
        _timerManager.addTimer(".place.girlown #easterUI .timer",from_php.easter_end,1);
    }
    main.find("#lickTrophy").qAnim({width:79, clips:13,
            interval:60,
            loop:1,
            two_side:1})
    //79px
    
}